
































































import { Component, Vue, Prop, Provide, Watch, Emit } from 'vue-property-decorator'
import { Modal } from '@/components'
import { ACheckbox, ARadio, AButton } from '@/components'

@Component({
  components: { Modal, ACheckbox, ARadio, AButton }
})
export default class DownLoadModal extends Vue {
  @Prop() public value!: boolean
  @Prop() public name!: string
  @Prop() public data!: any
  @Prop() public loading!: boolean
  public mainStyle = { padding: '40px 32px' }
  public visible = this.value
  public title = ''
  public value1 = 1
  public value2 = [1, 2, 4]
  public value3 = 1
  public plainOptions1 = [
    { label: 'DOC', value: 1 },
    { label: 'DOCX', value: 2 }
  ]
  public plainOptions2 = [
    { label: '分析', value: 1 },
    { label: '解答', value: 2 },
    { label: '点评', value: 4 },
    { label: '考点', value: 8 },
    { label: '专题', value: 16 },
    { label: '考点卡片', value: 32 },
    { label: '试卷来源', value: 64 }
  ]
  public plainOptions3 = [
    { label: '普通试卷（参考题干带题干）', value: 1 },
    { label: '教师试卷（参考答案不带题干）', value: 2 }
  ]

  @Watch('value')
  public onValueChange(val: boolean) {
    this.visible = val
    if (!val) {
      this.value1 = 1
      this.value2 = [1, 2, 4]
      this.value3 = 1
    } else {
      this.onChange(this.paramData())
    }
  }
  @Watch('value1')
  public onValue1Change(val: any) {
    this.onChange(this.paramData())
  }
  @Watch('value2', { deep: true })
  public onValue2Change(val: any) {
    this.onChange(this.paramData())
  }
  @Watch('value3')
  public onValue3Change(val: any) {
    this.onChange(this.paramData())
  }
  @Watch('loading')
  public onLoadingChange(val: boolean) {}

  @Emit()
  onCancel(val: any) {
    return val
  }
  @Emit()
  onDownload(val?: any) {
    return val
  }
  @Emit()
  onChange(val?: any) {
    return val
  }
  /**
   * closeModal
   */
  public closeModal() {
    this.visible = false
    this.onCancel(this.visible)
  }
  /**
   * download
   */
  public paramData() {
    let obj = {
      df: this.value1,
      da: this.value3,
      dm: 0
    }
    let temp = 0
    for (let n of this.value2) {
      temp = temp + ~~n
    }
    obj.dm = temp
    return obj
  }
  public download() {
    let obj = this.paramData()
    // console.log(obj)
    this.onDownload(obj)
  }
  /**
   * onChange1
   */
  public onChange1() {}
  /**
   * onChange2
   */
  public onChange2() {}
  /**
   * onChange3
   */
  public onChange3() {}
}
